import Vue from 'vue';
import Vuex from 'vuex';
import * as API from '@/services/API';
import _ from 'underscore';
import User from './modules/User';
import Project from './modules/Project';
import Activity from './modules/activity';
import Inspirations from './modules/Inspirations';

import { BAIN_TAGS } from '@/lib/constants';

import { DEFAULT_PRIVACY, DEFAULT_PERMISSION } from '@/lib/constants';
import { getRandomPhoto, triggerDownload } from '@/services/unsplash';

Vue.use(Vuex);

import createPlugin from 'logrocket-vuex';
import LogRocket from 'logrocket';

const logrocketPlugin = createPlugin(LogRocket);

export default new Vuex.Store({
    plugins: [logrocketPlugin],
    modules: {
        User,
        Project,
        Activity,
        Inspirations
    },
    state: {
        project: {},
        projectContent: [],
        projectBackground: undefined,
        projectBackgroundImage: undefined,
        IPLocation: {
            latitude: 0,
            longitude: 0,
        },
        clipboardContent: undefined,
        CREATION_ADJECTIVES_COLLECTION_ES: [
            'divertida',
            'interesante',
            'intrigante',
            'inspiradora',
            'histórica',
            'colectiva',
            'individual',
            'única',
            'luminosa',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_COLLECTION_CA: [
            'divertida',
            'interessant',
            'intrigant',
            'inspiradora',
            'històrica',
            'col·lectiva',
            'individual',
            'única',
            'lluminosa',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_COLLECTION_EN: [
            'funny',
            'interesting',
            'intriguing',
            'inspiring',
            'historical',
            'collective',
            'individual',
            'unique',
            'bright',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TRIVIAL_ES: [
            'divertido',
            'interesante',
            'intrigante',
            'inspirador',
            'histórico',
            'colectivo',
            'individual',
            'único',
            'luminoso',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TRIVIAL_CA: [
            'divertit',
            'interessant',
            'intrigant',
            'inspirador',
            'històric',
            'col·lectiu',
            'individual',
            'únic',
            'lluminos',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TRIVIAL_EN: [
            'funny',
            'interesting',
            'intriguing',
            'inspiring',
            'historical',
            'collective',
            'individual',
            'unique',
            'bright',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TRIVIALGEO_ES: [
            'divertido',
            'interesante',
            'intrigante',
            'inspirador',
            'histórico',
            'colectivo',
            'individual',
            'único',
            'luminoso',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TRIVIALGEO_CA: [
            'divertit',
            'interessant',
            'intrigant',
            'inspirador',
            'històric',
            'col·lectiu',
            'individual',
            'únic',
            'lluminos',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TRIVIALGEO_EN: [
            'funny',
            'interesting',
            'intriguing',
            'inspiring',
            'historical',
            'collective',
            'individual',
            'unique',
            'bright',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TREASUREHUNT_ES: [
            'divertido',
            'interesante',
            'intrigante',
            'inspirador',
            'histórico',
            'colectivo',
            'individual',
            'único',
            'luminoso',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TREASUREHUNT_CA: [
            'divertit',
            'interessant',
            'intrigant',
            'inspirador',
            'històric',
            'col·lectiu',
            'individual',
            'únic',
            'lluminos',
            'singular',
            'original',
        ],
        CREATION_ADJECTIVES_TREASUREHUNT_EN: [
            'funny',
            'interesting',
            'intriguing',
            'inspiring',
            'historical',
            'collective',
            'individual',
            'unique',
            'bright',
            'singular',
            'original',
        ],
        CREATION_VERBS_ES: [
            'investigar',
            'explorar',
            'conocer',
            'difundir',
            'emprender',
            'crear',
            'producir',
            'comunicar',
            'compartir',
            'entretener',
            'retar',
            'aprender',
            'inspirar',
        ],
        CREATION_VERBS_CA: [
            'investigar',
            'explorar',
            'conèixer',
            'difondre',
            'emprendre',
            'crear',
            'produïr',
            'comunicar',
            'compartir',
            'entretenir',
            'reptar',
            'aprendre',
            'inspirar',
        ],
        CREATION_VERBS_EN: [
            'to investigate',
            'to explore',
            'to meet',
            'to spread',
            'to undertake',
            'to create',
            'to produce',
            'to communicate',
            'to share',
            'to entertain',
            'to challenge',
            'to learn',
            'to inspire',
        ],
        objectModel: {
            type: 'object',
            title: { type: String, required: true },
            description: { type: String },
            media: [
                { name: 'images', type: Array },
                { name: 'tags', type: Array },
                { name: 'files', type: Array },
                { name: 'url', type: String },
                { name: 'audio', type: String },
                { name: 'video', type: String },
                { name: 'location', type: Object },
                { name: 'embed', type: String },
            ],
        },
        pointModel: {
            type: 'point',
            title: { type: String, required: true },
            media: [{ name: 'location', type: Object, required: true }],
        },
        questionModel: {
            type: 'question',
            title: { type: String, required: true },
            answerType: { type: String },
            related: [{ name: 'answers', type: Array, required: true }],
            media: [
                { name: 'images', type: Array },
                { name: 'files', type: Array },
                { name: 'url', type: String },
                { name: 'audio', type: String },
                { name: 'video', type: String },
                { name: 'location', type: Object },
                { name: 'tags', type: Array },
                { name: 'embed', type: String },
            ],
        },
        clueModel: {
            type: 'clue',
            description: { type: String, required: true },
            media: [
                { name: 'images', type: Array },
                { name: 'tags', type: Array },
                { name: 'files', type: Array },
                { name: 'url', type: String },
                { name: 'audio', type: String },
                { name: 'video', type: String },
                { name: 'embed', type: String },
            ],
        },
        goalModel: {
            type: 'point',
            media: [{ name: 'location', type: Object, required: true }],
        },
        session: undefined,
        projectChanges: [],
        projectComments: [],
        community: {},
        communityImageUrl: undefined,
        communityFeed: [],
        communityParticipants: [],
        communities: [],
        communityActivityTags: BAIN_TAGS,
        activeFolder: undefined,
        defaultProjectConfiguration: {
            global: {
                likes: true,
                comments: true,
                order: 'REVERSE',
                thread: 'ALL',
            },
        },
        communityEvents: [],
        renderNavbar: true,
    },
    mutations: {
        SET_PROJECT(state, project) {
            if (_.isArray(project.image)) {
                if (project.image.length > 0) {
                    console.error(
                        'Project image is an array instead of an object'
                    );
                }
                delete project.image;
            }
            state.project = Object.assign({}, project);
            state.projectBackground = project.background;
            state.projectBackgroundImage = project.backgroundImage;
            state.Project.cardSize = project.layout
                ? project.layout.cardSize
                : 'SMALL';

            if (project.type == 'treasurehunt') {
                state.Project.cardSize = 'LARGE';
            }

            if (project.layout) {
                state.Project.layout = project.layout.type;
            } else {
                state.Project.layout = 'GRID';
            }
            if (!project.configuration) {
                //TODO: remove once all changes merged
                project.configuration = state.defaultProjectConfiguration;
            }
            state.Project.order = project.configuration.global.order;
        },
        SET_PROJECT_BACKGROUND(state, background) {
            //state.project = { ...state.project, ...{ background } };
            state.projectBackground = background;
        },
        SET_PROJECT_BACKGROUND_IMAGE(state, backgroundImage) {
            //state.project = { ...state.project, ...{ background } };
            state.projectBackgroundImage = backgroundImage;
        },
        SET_PROJECT_CONTENT(state, content) {
            state.projectContent = content;
        },
        ADD_OBJECT_TO_PROJECT(state, object) {
            if (_.findWhere(state.projectContent, { _id: object._id })) {
                return console.warn('object found, not adding', object._id);
            }
            state.projectContent.push(object);
        },
        UPDATE_OBJECT(state, object) {
            const updatedIndex = _.findIndex(state.projectContent, {
                _id: object._id,
            });

            const draftIndex = _.findIndex(state.projectContent, {
                _id: 'draft',
            });

            state.projectContent.splice(updatedIndex, 1, object);

            if (-1 !== draftIndex) {
                state.projectContent.splice(draftIndex, 1);
            }
        },
        REMOVE_OBJECT_FROM_PROJECT(state, object_id) {
            state.projectContent = _.reject(state.projectContent, (obj) => {
                return obj._id == object_id;
            });
        },
        ADD_COMMENT_TO_PROJECT(state, comment) {
            if (_.findWhere(state.projectComments, { _id: comment._id })) {
                return;
            }
            state.projectComments.push(comment);
            if (comment.owner.owner !== state.User.userProfile.owner) {
                state.project.pendingComments++;
            }
        },
        CLEAN_PROJECT(state) {
            state.project = {};
            state.projectContent = [];
            state.projectBackground = undefined;
            state.projectBackgroundImage = undefined;
            //TODO change to a reset or set defaults in Project module.
            state.Project = {
                ...state.Project,
                ...{
                    showConfiguration: false,
                    showPrivacy: false,
                    showChanges: false,
                    showComments: false,
                    showParticipants: false,
                    creationEnabled: false,
                    layout: 'COLUMNS',
                    cardSize: 'SMALL',
                    order: 'REVERSE',
                },
            };
        },
        SET_IP_LOCATION(state, location) {
            state.IPLocation.latitude = location.latitude;
            state.IPLocation.longitude = location.longitude;
        },
        SET_CLIPBOARD_CONTENT(state, content) {
            state.clipboardContent = content;
        },
        SET_GAME_SESSION(state, session) {
            state.session = session;
        },
        CLEAR_GAME_SESSION(state) {
            state.session = undefined;
            state.projectBackground = undefined;
            state.projectBackgroundImage = undefined;
        },
        SET_PROJECT_CHANGES(state, content) {
            state.projectChanges = content;
        },
        RESET_PROJECT_CHANGES_COUNT(state) {
            state.project.pendingChanges = 0;
        },
        SET_PROJECT_COMMENTS(state, content) {
            state.projectComments = content;
        },
        RESET_PROJECT_COMMENTS_COUNT(state) {
            state.project.pendingComments = 0;
        },
        UPDATE_COMMENT(state, { _id, comment }) {
            let oldComment = _.findWhere(state.projectComments, { _id });
            oldComment.likes = comment.likes;
            oldComment.liked = comment.liked;
        },
        ADD_CHANGE_TO_PROJECT(state, change) {
            if (_.findWhere(state.projectChanges, { _id: change._id })) {
                return;
            }
            state.projectChanges.unshift(change);
            if (change.owner.owner !== state.User.userProfile.owner) {
                state.project.pendingChanges++;
            }
        },
        DELETE_OBJECT(state, content) {
            if (_.findWhere(state.projectContent, { _id: content._id })) {
                state.projectContent = state.projectContent.filter(function (
                    item
                ) {
                    return item['_id'] != content._id;
                });
                return;
            }
        },
        SET_COMMUNITY(state, community) {
            state.community = Object.assign({}, community);
            if (community.image) {
                state.communityImageUrl = community.image.url;
            } else {
                state.communityImageUrl = undefined;
            }
        },
        SET_COMMUNITY_FEED(state, content) {
            state.communityFeed = content;
        },
        ADD_POST_TO_COMMUNITY(state, object) {
            if (_.findWhere(state.communityFeed, { _id: object._id })) {
                return;
            }
            state.communityFeed.unshift(object);
        },
        UPDATE_POST(state, post) {
            const updatedIndex = _.findIndex(state.communityFeed, {
                _id: post._id,
            });

            state.projectContent.splice(updatedIndex, 1, post);
        },
        DELETE_POST(state, object) {
            state.communityFeed = _.without(state.communityFeed, object);
        },
        SET_COMMUNITIES(state, content) {
            state.communities = content;
        },
        SET_COMMUNITY_ACTIVITY_TAGS(state, content) {
            state.communityActivityTags = content;
        },
        ADD_ACTIVITY_TO_COMMUNITY(state, object) {
            const folder = _.findWhere(state.community.activityFolders, {
                _id: object.folder,
            });
            if (_.findWhere(folder.activities, { _id: object._id })) {
                return;
            }
            if (!folder.activities) {
                folder.activities = [];
            }
            folder.activities.unshift(object);
            _.extend(
                _.findWhere(state.community.activityFolders, {
                    _id: object.folder,
                }),
                folder
            );
        },
        REMOVE_COMMUNITY_ACTIVITY(state, data) {
            const folder = _.findWhere(state.community.activityFolders, {
                _id: state.activeFolder,
            });

            folder.activities = _.reject(folder.activities, (obj) => {
                return obj._id == data.activityId;
            });
        },
        UPDATE_COMMUNITY_ACTIVITY(state, object) {
            const folder = _.findWhere(state.community.activityFolders, {
                _id: object.folder,
            });
            const updatedIndex = _.findIndex(folder.activities, {
                _id: object._id,
            });
            if (updatedIndex == -1) {
                //new activity in the folder
                folder.activities = folder.activities || [];
                folder.activities.push(object);
            } else {
                folder.activities.splice(updatedIndex, 1, object);
            }
        },

        ADD_COMMUNITY_ACTIVITY_TO_FOLDER(state, data) {
            const folder = _.findWhere(state.community.activityFolders, {
                _id: data.folder._id,
            });
            folder.activities.push(data.activity);
        },

        ADD_ACTIVITY_FOLDER(state, object) {
            if (
                _.findWhere(state.community.activityFolders, {
                    _id: object._id,
                })
            ) {
                return;
            }
            if (!_.isArray(state.community.activityFolders)) {
                console.warn('initializing activityFolders');
                state.community.activityFolders = [];
            }
            state.community.activityFolders.push(object);
        },
        UPDATE_ACTIVITY_FOLDER(state, object) {
            const updatedIndex = _.findIndex(state.community.activityFolders, {
                _id: object._id,
            });
            state.community.activityFolders.splice(updatedIndex, 1, object);
        },
        REMOVE_ACTIVITY_FOLDER(state, _id) {
            state.community.activityFolders = _.reject(
                state.community.activityFolders,
                (obj) => {
                    return obj._id == _id;
                }
            );
        },
        SET_ACTIVE_FOLDER(state, folderId) {
            state.activeFolder = folderId;
        },
        WATCH_PROJECT(state) {
            state.project.watching = true;
        },
        UNWATCH_PROJECT(state) {
            state.project.watching = false;
        },
        UPDATE_COMMUNITY_CONFIGURATION(state, preferences) {
            state.community.preferences = preferences;
        },
        UPDATE_CIRCLE(state, object) {
            const updatedIndex = _.findIndex(state.community.circles, {
                _id: object._id,
            });
            state.community.circles.splice(updatedIndex, 1, object);
        },
        REMOVE_CIRCLE(state, _id) {
            state.community.circles = _.reject(
                state.community.circles,
                (obj) => {
                    return obj._id == _id;
                }
            );
        },
        INCREMENT_PENDING_MESSAGES(state, circleId) {
            _.each(state.community.circles, (circle) => {
                if (circle._id == circleId) {
                    circle.pendingMessages = circle.pendingMessages + 1;
                }
            });
        },
        CLEAR_PENDING_MESSAGES(state, circleId) {
            if (!state.community.circles) {
                return;
            }
            const activeCircle = _.find(state.community.circles, {
                _id: circleId,
            });
            activeCircle.pendingMessages = 0;
            const updatedIndex = _.findIndex(state.community.circles, {
                _id: circleId,
            });
            state.community.circles.splice(updatedIndex, 1, activeCircle);
        },
        INCREMENT_PENDING_ACTIVITIES(state, activity) {
            _.each(state.community.activityFolders, (folder) => {
                if (folder._id == activity['folder']) {
                    folder.pendingActivities = folder.pendingActivities + 1;
                }
            });
        },
        DECREMENT_PENDING_ACTIVITIES(state, activity) {
            _.each(state.community.activityFolders, (folder) => {
                if (folder._id == activity.folder) {
                    _.each(folder.activities, (folderActivity) => {
                        if (folderActivity._id == activity._id) {
                            if (!folderActivity.viewed) {
                                folder.pendingActivities =
                                    folder.pendingActivities - 1;
                            }
                        }
                    });
                }
            });
        },
        CLEAR_PENDING_ACTIVITIES(state, folderId) {
            if (!state.community.activityFolders) {
                return;
            }
            const folderActive = _.find(state.community.activityFolders, {
                _id: folderId,
            });
            folderActive.pendingActivities = 0;
            const updatedIndex = _.findIndex(state.community.activityFolders, {
                _id: folderId,
            });
            state.community.activityFolders.splice(
                updatedIndex,
                1,
                folderActive
            );
        },
        CLEAR_PENDING_POSTS(state) {
            if (!state.community.pendingPosts) {
                return;
            }
            state.community.pendingPosts = 0;
        },
        SET_COMMUNITY_EVENTS(state, events) {
            state.communityEvents = events;
        },
        SET_COMMUNITY_EVENT(state, event) {
            state.communityEvents.push(event);
        },
        UPDATE_COMMUNITY_EVENT(state, object) {
            const eventIndex = _.findIndex(state.communityEvents, {
                _id: object._id,
            });
            if (eventIndex == -1) {
                state.communityEvents.push(object);
            } else {
                state.communityEvents.splice(eventIndex, 1, object);
            }
        },
        REMOVE_COMMUNITY_EVENT(state, event) {
            state.communityEvents = _.reject(state.communityEvents, (obj) => {
                return obj._id == event._id;
            });
        },
        SET_USER_PROJECT_CONFIGURATION(state, userConfigurationData) {
            state.project.userConfiguration = userConfigurationData;
        },
        SET_RENDER_NAVBAR(state, value) {
            state.renderNavbar = value;
        },
        SET_COMMUNITY_USER_PREFERENCES(state, value) {
            state.community.preferences = value;
        },
        SET_COMMUNITY_PENDING_POSTS(state, value) {
            state.community.pendingPosts = value;
        },
        SET_COMMUNITY_FOLDER_METADATA(state, object) {
            const folderIndex = _.findIndex(state.community.activityFolders, {
                _id: object._id,
            });
            if (folderIndex != -1) {
                let folderData = state.community.activityFolders[folderIndex];
                folderData.accessLevel = object.accessLevel;
                folderData.pendingActivities = object.pendingActivities;
                state.community.activityFolders.splice(folderIndex, 1, folderData);
            }
        },
        SET_COMMUNITY_CIRCLE_METADATA(state, object) {
            const circleIndex = _.findIndex(state.community.circles, {
                _id: object._id,
            });
            if (circleIndex != -1) {
                let circleData = state.community.circles[circleIndex];
                circleData.pendingMessages = object.pendingMessages;
                state.community.circles.splice(circleIndex, 1, circleData);
            }
        },

    },
    actions: {
        async fetchProject({ commit }, payload) {
            const response = await API.fetchItem('project', payload);
            if (response.data) {
                commit(
                    'SET_PROJECT',
                    !_.isArray(response.data) ? response.data : response.data[0]
                );
            }
        },
        async updateProject({ commit }, { id, project }) {
            const response = await API.updateItem('project', id, project);
            if (response.data) {
                commit('SET_PROJECT', { ...response.data, ...{ _id: id } });
            }
        },
        updateObjectsOrder({ commit }, objects) {
            if (this.getters.projectConfiguration.global.order == 'FORWARD') {
                _.each(objects, async (object, index) => {
                    if (object.order != index + 1) {
                        // console.log("changing order for " + object.title + " from " + object.order + " to " + (index + 1))
                        object.order = index + 1;
                    } else {
                        // console.log("maintain order for " + object.title + " from " + object.order + " to " + (index + 1))
                    }
                });
            } else {
                _.each(objects, async (object, index) => {
                    if (object.order != objects.length - index) {
                        // console.log("changing reverse order for " + object.title + " from " + object.order + " to " + (objects.length - (index)))
                        object.order = objects.length - index;
                    } else {
                        // console.log("maintain reverse order for " + object.title + " from " + object.order + " to " + (objects.length - (index)))
                    }
                });
            }
            commit('SET_PROJECT_CONTENT', objects);
        },
        async fetchProjectContent({ commit, state }, { _id }) {
            let response = await API.fetchItems('object', {
                project: _id,
            });
            commit('SET_PROJECT_CONTENT', response.data);
        },
        async createObject({ commit }, object) {
            let response = await API.createItem('object', object);
            commit('ADD_OBJECT_TO_PROJECT', response.data);
            return response.data;
        },

        async updateObject({ commit }, object) {
            commit('UPDATE_OBJECT', object);
            let response = await API.updateItem('object', object._id, object);
            //dispatch("fetchProjectContent");
            return response.data;
        },
        deleteObject({ commit }, object_id) {
            commit('REMOVE_OBJECT_FROM_PROJECT', object_id);
            API.deleteItem('object', object_id);
        },
        cleanProject({ commit }) {
            commit('CLEAN_PROJECT');
        },
        changeBackground({ commit }, newBackground) {
            commit('SET_PROJECT_BACKGROUND', newBackground);
        },
        changeBackgroundImage({ commit }, newBackgroundImage) {
            commit('SET_PROJECT_BACKGROUND_IMAGE', newBackgroundImage);
        },
        setClipboardContent({ commit }, content) {
            commit('SET_CLIPBOARD_CONTENT', content);
        },
        setSession({ commit }, content) {
            commit('SET_GAME_SESSION', content);
            commit('SET_PROJECT_BACKGROUND', content.project.background);
            commit('SET_PROJECT_BACKGROUND_IMAGE', content.project.background);
        },
        async resetSession({ commit, state }, content) {
            const sessionRequest = await API.resetSession(state.session._id);
            const session = sessionRequest.data;
            commit('SET_GAME_SESSION', session);
            commit('SET_PROJECT_BACKGROUND', session.project.background);
            commit('SET_PROJECT_BACKGROUND_IMAGE', session.project.background);
        },
        cleanSession({ commit }) {
            commit('CLEAR_GAME_SESSION');
        },
        async createProject(
            { commit, state },
            { type, title, description, mode, folder }
        ) {
            let photo = await getRandomPhoto({
                featured: true,
                query: 'amazing',
            });
            triggerDownload(photo);
            let layout;
            let configuration = state.defaultProjectConfiguration;

            if (type != 'storytelling') {
                layout = {
                    cardSize: 'SMALL',
                    type: 'COLUMNS',
                };
            } else {
                configuration.global.order = 'FORWARD';
                layout = {
                    cardSize: 'LARGE',
                    type: 'VERTICAL',
                };
            }

            return await API.createItem('project', {
                type,
                title,
                mode,
                layout,
                configuration,
                description,
                background: { type: 'unsplash', value: photo },
                privacy: DEFAULT_PRIVACY,
                defaultPermission: DEFAULT_PERMISSION,
                folder
            });
        },
        async fetchProjectChanges({ commit, state }, payload) {
            const response = await API.fetchChanges(
                'project',
                state.project._id
            );
            if (response.data) {
                commit('RESET_PROJECT_CHANGES_COUNT');
                commit('SET_PROJECT_CHANGES', response.data);
            }
        },
        async fetchProjectComments({ commit, state }, payload) {
            const response = await API.fetchComments(
                'project',
                state.project._id
            );
            if (response.data) {
                commit('RESET_PROJECT_COMMENTS_COUNT');
                commit('SET_PROJECT_COMMENTS', response.data);
            }
        },

        async toggleProjectLike({ commit, state }, { _id }) {
            const result = await API.likeProject(_id);
            commit('SET_PROJECT', result.data);
        },

        async fetchCommunity({ commit }, payload) {
            const response = await API.fetchItem('community', payload);
            if (response.data) {
                commit('SET_COMMUNITY', response.data);
            }
        },
        /*async updateCommunityActivities({ commit, state }, { activities }) {
                    let community = state.community;
                    community.activities = activities;
                    console.log("updating activities");
                    const response = await API.updateItem(
                        "community",
                        community._id,
                        community
                    );
                    if (response.data) {
                        commit("SET_COMMUNITY", response.data);
                    }
                },*/
        async fetchCommunityFeed({ commit }, { id }) {
            let response = await API.fetchCommunityFeed(id).catch((e) => {
                throw e;
            });
            commit('SET_COMMUNITY_FEED', response.data);
        },
        async createPost({ commit }, { object, id }) {
            let response = await API.addPost('community', id, object);
            commit('ADD_POST_TO_COMMUNITY', response.data);
            return response.data;
        },
        async updatePost({ commit }, { post, community }) {
            let response = await API.updatePost(community, post);
            commit('UPDATE_POST', response.data);
            return response.data;
        },
        async deletePost({ commit }, { community, post }) {
            commit('DELETE_POST', post);
            API.deleteCommunityPost(community, post._id);
        },
        async fetchPublicCommunities({ commit }) {
            let response = await API.fetchPublicCommunities();
            commit('SET_COMMUNITIES', response.data);
        },
        async fetchMyCommunities({ commit }) {
            let response = await API.fetchMyCommunities();
            commit('SET_COMMUNITIES', response.data);
        },
        async createActivity({ commit }, { object, id }) {
            let response = await API.addActivity('community', id, object);
            commit('ADD_ACTIVITY_TO_COMMUNITY', response.data);
            return response.data;
        },
        deleteActivity({ commit, state }, data) {
            commit('REMOVE_COMMUNITY_ACTIVITY', data);
            API.deleteActivity(data.communityId, data.activityId);
        },
        async updateActivity({ commit }, { object, id }) {
            commit('UPDATE_COMMUNITY_ACTIVITY', object);
            let response = await API.updateActivity('community', id, object);
            return response.data;
        },
        async moveCommunityActivity({ commit, state, dispatch }, data) {
            commit('REMOVE_COMMUNITY_ACTIVITY', {
                activityId: data.activity._id,
            });
            data.activity.folder = data.folder._id;
            if (data.community._id == state.community._id) {
                dispatch('updateActivity', {
                    object: data.activity,
                    id: data.community._id,
                });
            } else {
                API.updateActivity(
                    'community',
                    data.community._id,
                    data.activity
                );
            }
        },
        cleanCommunity({ commit }) {
            commit('SET_COMMUNITY_FEED', []);
            commit('SET_COMMUNITY', {});
            commit('SET_COMMUNITY_EVENTS', []);
        },
        async addActivityFolder({ commit }, { object, id }) {
            let response = await API.addCommunityItem(
                'communityActivityFolder',
                id,
                object
            );
            commit('ADD_ACTIVITY_FOLDER', response.data);
        },
        async updateActivityFolder({ commit }, { object, id }) {
            let response = await API.updateCommunityItem(
                'communityActivityFolder',
                object._id,
                id,
                object
            );
            commit('UPDATE_ACTIVITY_FOLDER', response.data);
        },
        async deleteActivityFolder({ commit }, data) {
            let response = await API.deleteActivityFolder(
                data.communityId,
                data.folderId
            );
            commit('REMOVE_ACTIVITY_FOLDER', data.folderId);
        },
        async startWatchingProject({ commit }, id) {
            API.watchProject(id);
            // API.watchProject(id);
            commit('WATCH_PROJECT');
        },
        async stopWatchingProject({ commit }, id) {
            API.unwatchProject(id);
            commit('UNWATCH_PROJECT');
        },
        updateCommunityConfiguration({ commit }, preferences) {
            commit('UPDATE_COMMUNITY_CONFIGURATION', preferences);
        },
        async publishActivity({ commit }, { communityId, activityId }) {
            let response = await API.publishActivity(
                'community',
                communityId,
                activityId
            );
            return response.data;
        },
        async unpublishActivity({ commit }, { communityId, activityId }) {
            let response = await API.unpublishActivity(
                'community',
                communityId,
                activityId
            );
            return response.data;
        },
        async duplicateActivity({ commit }, { communityId, activity }) {
            let response = await API.duplicateActivity(
                'community',
                communityId,
                activity
            );
            commit('ADD_ACTIVITY_TO_COMMUNITY', response.data);
            return response.data;
        },
        async updateCircle({ commit }, { object, id }) {
            let response = await API.updateCommunityItem(
                'circle',
                object._id,
                id,
                object
            );
            commit('UPDATE_CIRCLE', response.data);
        },
        async deleteCircle({ commit }, data) {
            let response = await API.deleteCircle(
                data.communityId,
                data.circleId
            );
            commit('REMOVE_CIRCLE', data.circleId);
        },
        async fetchCommunityCalendar({ commit }, id) {
            let response = await API.fetchCommunityCalendarEvents(id);
            commit('SET_COMMUNITY_EVENTS', response.data);
        },
        async updateUserProjectConfiguration(
            { commit },
            { projectId, userConfigurationData }
        ) {
            const response = await API.updateUserProjectConfiguration(
                projectId,
                userConfigurationData
            );
            if (response.data) {
                commit('SET_USER_PROJECT_CONFIGURATION', { ...response.data });
            }
        },
        async fetchCommunityMetadata({ commit }, id) {
            const response = await API.fetchCommunityMetadata(id);
            if (response.data) {
                //commit('SET_COMMUNITY_USER_PREFERENCES', response.data.preferences);
                commit('SET_COMMUNITY_PENDING_POSTS', response.data.pendingPosts);
                for (let folder of response.data.folders) {
                    commit('SET_COMMUNITY_FOLDER_METADATA', folder);
                }
                for (let circle of response.data.circles) {
                    commit('SET_COMMUNITY_CIRCLE_METADATA', circle);
                }
            }
        },
        async createProjectForImport(
            { commit, state },
            { type, title, description, mode, image }
        ) {
            let photo = await getRandomPhoto({
                featured: true,
                query: 'amazing',
            });
            triggerDownload(photo);
            let layout;
            let configuration = state.defaultProjectConfiguration;

            if (type != 'storytelling') {
                layout = {
                    cardSize: 'SMALL',
                    type: 'COLUMNS',
                };
            } else {
                configuration.global.order = 'FORWARD';
                layout = {
                    cardSize: 'LARGE',
                    type: 'VERTICAL',
                };
            }

            return await API.createItem('project', {
                type,
                title,
                mode,
                layout,
                configuration,
                description,
                background: { type: 'unsplash', value: photo },
                privacy: DEFAULT_PRIVACY,
                defaultPermission: DEFAULT_PERMISSION,
                image,
            });
            //return {}
        },
        async duplicateProject(
            { commit, state },
            { projectData,content }
        ) {
            /*let photo = await getRandomPhoto({
                featured: true,
                query: 'amazing',
            });
            triggerDownload(photo);*/
            // let layout;
            
            let configuration = {};
            configuration.global = _.defaults(projectData.configuration.global, state.defaultProjectConfiguration.global);
            projectData.configuration = {...configuration}
            
            if (!projectData.layout) {
                let layout;
                if (projectData.type != 'storytelling') {
                    layout = {
                        cardSize: 'SMALL',
                        type: 'COLUMNS',
                    };
                } else {
                    layout = {
                        cardSize: 'LARGE',
                        type: 'VERTICAL',
                    };
                }
                projectData.layout = layout;
            }

            if (!projectData.background || !projectData.background.type || !projectData.background.value || (projectData.background.type != 'gradient' && !projectData.background.value.urls)) {
                let photo = await getRandomPhoto({
                    featured: true,
                    query: 'amazing',
                });
                triggerDownload(photo);
                projectData.background = { type: 'unsplash', value: photo };
            }

            if (projectData.backgroundImage && projectData.backgroundImage._id === null) {
                delete projectData.backgroundImage;
            }

            if (projectData.image && projectData.image._id === null) {
                delete projectData.image;
            }

            delete projectData.created;
            delete projectData.modified;
            delete projectData.sharedWith;
            delete projectData.shortCode;
            delete projectData.watchers;


            return await API.createItem('project', projectData);

        },
    },
    getters: {
        project: (state) => state.project,
        projectConfiguration: (state) =>
            state.project.configuration || state.defaultProjectConfiguration,
        canCommentInObjects: (state, getters) => {
            return getters.projectConfiguration.global.comments === true;
        },
        canLikeObjects: (state, getters) => {
            return getters.projectConfiguration.global.likes === true;
        },
        canCommentInProject: (state, getters) => {
            const permissionLevel = getters.projectConfiguration.global.thread;
            switch (permissionLevel) {
                case 'ALL':
                    return true;
                case 'NONE':
                    return false;
                case 'ONLY_ADMINISTRATORS':
                    return state.project.accessLevel == 'administrator';
            }
        },
        projectBackground: (state) => state.projectBackground,
        projectBackgroundImage: (state) => state.projectBackgroundImage,
        projectImage: (state) => {
            if (!_.isEmpty(state.projectBackgroundImage)) {
                return state.projectBackgroundImage.url;
            } else if (
                state.projectBackground &&
                state.projectBackground.type == 'unsplash'
            ) {
                return state.projectBackground.value.urls.regular;
            }
            return null;
        },
        projectContent: (state) => state.projectContent,
        IPLocation: (state) => state.IPLocation,
        IPLocationArray: (state) => [
            state.IPLocation.longitude,
            state.IPLocation.latitude,
        ],
        clipboardContent: (state) => state.clipboardContent,
        participants: (state) =>
            state.session ? state.session.participants : [],
        questions: (state) => (state.session ? state.session.context : []),
        objectModel: (state) => state.objectModel,
        questionModel: (state) => state.questionModel,
        pointModel: (state) => state.pointModel,
        clueModel: (state) => state.clueModel,
        goalModel: (state) => state.goalModel,
        itemById: (state) => {
            return (_id) => {
                return _.findWhere(state.projectContent, {
                    _id,
                });
            };
        },
        projectChanges: (state) => state.projectChanges,
        projectComments: (state) => state.projectComments,
        community: (state) => state.community,
        communityActivityFolders: (state) => state.community.activityFolders,
        communityImageUrl: (state) => state.communityImageUrl,
        communityFeed: (state) => state.communityFeed,
        communityParticipants: (state) => state.communityParticipants,
        communities: (state) => state.communities,
        adminCommunities: (state) => {
            return _.filter(state.communities, (community) => {
                return community.accessLevel == 'administrator';
            });
        },
        communityActivityTags: (state) => state.communityActivityTags,
        communityActivities: (state) => {
            return _.chain(state.community.activityFolders)
                .pluck('activities')
                .flatten()
                .value();
        },
        showLoginForm: (state) => state.User.showLoginForm,
        communityEvents: (state) => state.communityEvents,
        hasCommunities: (state) => !!state.communities.length,
        renderNavbar: (state) => state.renderNavbar,
    },
});
